import React, { useState } from "react";
//import zxcvbn from 'zxcvbn';
import { mainDivMobile, row, column, borderLine } from "./styles";
import validator from "validator";
import { Link } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGoogle,
  faApple,
} from "@fortawesome/free-brands-svg-icons";
import { screenSizeWithOutMenus, paddingForInputs } from '../multiFunctions';
import { login } from './functions';


function LoginMobile() {
  const [ ErrorEmail, setErrorEmail] = useState('');
  
  const [ inputPassword, setInputPassword] = useState('');
  const [ inputEmail, setInputEmail ] = useState('');

  const handleInputChange = (event) => {
      const name = event && event.target && event.target.id;
      const value = event && event.target && event.target.value;
      if (name && value) {
        switch(name) {
          case "password":
            setInputPassword(value);
            //setErrorPassword("");
            break;
          case "email":
            setInputEmail(value);
            setErrorEmail("");
            break;
          default:
            break;
        }
      }
    }
  
    const handleSubmit = function (event) {
    let loginObj = {
      email: inputEmail,
      password: inputPassword
    }
    let isValidEmail = validatorInput('email', loginObj);

    if (isValidEmail) {
      login(loginObj);
    }
     
    };
  
    const validatorInput = function(typeIn, objIn) {
      let isValid = true;
      //let result = null;
      switch(typeIn) {
          case "email":
                  if (!validator.isEmail(objIn.email)) {
                      setErrorEmail('Error please add a valid email');
                      isValid = false;
                  } else {
                      setErrorEmail("");
                  }
              break;
          case "password":
                  if (objIn.password.length > 6) {
                    /*result = zxcvbn(objIn.password);
                    if (result.score <= 3) {
                      if (result && result.feedback && result.feedback.suggestions.join(" ")) {
                        
                        isValid = false;
                      }
                    }*/
                  } else {
                    
                    isValid = false;
                  }
              break;
          default:
              break;
  
      }
      return isValid;
    }


  let mainDivMobile2 = mainDivMobile;
  
  if (!mainDivMobile2.height) {
    mainDivMobile2.height = screenSizeWithOutMenus;
  }
  
  let styleFontSize = {
    fontSize: "medium",
  };

  let containerDiv = {
    ...row,
    textAlign: "center",
    styleFontSize,
    margin: "5px",
    width: "96%",
    display: "flex",
    flexFlow: "column"
  };

  let movileFontSize = {
    fontSize: "medium",
    paddingTop: "15px",
  };

  let fontSizeXLarge = { fontSize: "xx-large" };
  let fontSizeLarge = { fontSize: "x-large" };
  return (
          <div style={mainDivMobile2}>
            <div id="segundo" style={containerDiv}>
              <div style={{
                    ...column,
                    paddingTop: "15px",
                    backgroundColor: "white",
                    borderRadius: "30px 30px 0px 0px",
                  }}>
                
                  <div style={{ ...fontSizeXLarge,
                      paddingTop: "15px",
                      textAlign: "center",
                    }} >
                    Login
                  </div>
                
                <div
                  style={{ ...row, ...fontSizeLarge, paddingTop: "15px" }}>
                  Email
                </div>
                <div style={{ ...row, paddingTop: "15px", width: "90%" }}>
                  <TextField
                    id="email"
                    variant="standard"
                    label=""
                    fullWidth
                    style={borderLine}
                    onChange={handleInputChange}
                    error={!!ErrorEmail}
                    helperText={ErrorEmail}
                    sx={{ '& .MuiFormHelperText-root': { ...paddingForInputs, color: "red", fontWeight: "700", position: "relative", top: "20px" } }}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        ...paddingForInputs,
                        border: "none",
                        outline: "none",
                        backgroundColor: "transparent",
                      },
                    }}
                  />
                </div>
                <div
                  style={{ ...row, ...fontSizeLarge, paddingTop: "15px" }}
                >
                  Password
                </div>
                <div style={{ ...row, paddingTop: "15px", width: "90%" }}>
                  <TextField
                    id="password"
                    variant="standard"
                    label=""
                    fullWidth
                    type="password"
                    style={borderLine}
                    onChange={handleInputChange}
                    sx={{ '& .MuiFormHelperText-root': { ...paddingForInputs, color: "red", fontWeight: "700", position: "relative", top: "20px" } }}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        border: "none",
                        outline: "none",
                        backgroundColor: "transparent",
                        ...paddingForInputs
                      },
                    }}
                  />
                </div>
                <div style={{ ...movileFontSize }}>
                  Forgot your password?
                </div>
                <div style={{ ...fontSizeLarge, paddingTop: "15px" }} >
                  <Button
                    onClick={handleSubmit}
                    type="submit"
                    variant="contained"
                    sx={{
                      borderRadius: "30px",
                      backgroundColor: "white",
                      color: "black",
                      width: "150px"
                    }} >
                    Login
                  </Button>
                </div>
                <div style={{  paddingTop: "15px", ...fontSizeXLarge, display: "none" }}>
                  <div style={{ paddingRight: "10px" }}>
                    <FontAwesomeIcon icon={faFacebookF} />
                  </div>
                  <div style={{ paddingRight: "10px" }}>
                    <FontAwesomeIcon icon={faGoogle} />
                  </div>
                  <div>
                    <FontAwesomeIcon icon={faApple} />
                  </div>
                </div>
                <div style={{ ...movileFontSize, paddingBottom: "15px" }}>
                  use your email to log in
                </div>
              </div>
              <DivBottomPart/>
            </div>
          </div>
        )
}


function DivBottomPart() {
  return (
    
      <div style={{
          borderRadius: "0px 0px 30px 30px",
          backgroundColor: "#8fa464",
          color: "white", 
          marginBottom: "10px"
        }} >
        <div style={{ fontSize: "xx-large", textAlign: "center" }}>
          <p>You don&apos;t have an account? </p>
        </div>
        <div style={{ paddingTop: "10px", paddingBottom: "15px" }}>
          <Link
            to="/register"
            style={{ color: "white", textDecoration: "underline" }}>
            Click here
          </Link>
        </div>
      </div>
    
  )
}

export default LoginMobile;
